// Share links go to the standalone preview page (src/preview). On its own domain the
// link is nothing but the domain and the hash. Until that domain exists the page is
// served from the current one under /p/, since the root there belongs to the CRM.
//
// The domain is baked in at build time from VUE_APP_PREVIEW_ORIGIN, like the other
// VUE_APP_* settings each environment's build writes into .env.
export const canvasPreviewLink = (hash) => {
  const previewOrigin = import.meta.env.VUE_APP_PREVIEW_ORIGIN || "";
  const path = encodeURIComponent(hash);
  return previewOrigin
    ? `${previewOrigin.replace(/\/+$/, "")}/${path}`
    : `${window.location.origin}/p/${path}`;
};
